<template>
  <v-container fluid>
    <!-- {{ getParams() }} -->
    <v-row>
      <v-col>
        <v-card flat width="20%">
          <v-card-text>
            <v-menu ref="fechaDialogReporte" v-model="modalFechas" :close-on-content-click="false" :nudge-right="-17"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="selectedRangueFecha" label="Días" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker :selected-items-text="'$vuetify.datePicker.itemsSelected'" locale="es" width="240" no-title
                scrollable v-model="dialogVarSelectedRangueFecha" range :max="disabledFecha" color="primary"
                header-color="primary">
                <v-spacer></v-spacer>
                <!-- <v-btn text color="primary" @click="setModalFechas(false)">
                  Cancelar
                </v-btn> -->
                <v-btn text color="primary" @click="saveDateRange(dialogVarSelectedRangueFecha), setModalFechas(false)">
                  cerrar
                </v-btn>
              </v-date-picker>
            </v-menu>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table disable-pagination :options.sync="options" :hide-default-footer="true" :headers="headers"
      :items="items">
      <template v-slot:top>
        <v-row no-gutters>
          <v-spacer>

          </v-spacer>
          <v-btn x-small @click="main()" class="mt-3 ml-1 mr-1 flo" color="primary">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
          <v-btn x-small @click="applyFilters" class="mt-3 ml-1 mr-1 flo" color="primary">
            Búscar
          </v-btn>

          <v-btn :loading="loading" x-small @click="exportToExcel" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a Excel
          </v-btn>
          <v-btn :loading="loading" x-small @click="exportToPDF" class="mt-3 ml-1 mr-1 flo" color="success">
            Exportar a PDF
          </v-btn>
        </v-row>
      </template>
      <template v-slot:header>
        <tr>
          <td v-for="header in filteredHeaders" :key="header.value">
            <v-text-field @keydown.enter="applyFilters()" dense
              v-if="header.type === 'date' || header.type === 'datetime' || header.type === 'dateUTC'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'string'"
              v-model="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-text-field @keydown.enter="applyFilters()" dense v-if="header.type === 'integer'" type="number" step="1"
              v-model.number="filters[header.value]" :label="`${header.text}`" hide-details solo></v-text-field>
            <v-select @change="applyFilters()" clearable dense v-if="header.type === 'boolean'"
              v-model="filters[header.value]" :items="booleanOptions" :label="`${header.text}`" hide-details
              solo></v-select>
            <!-- Add other input types as needed -->
          </td>
        </tr>

      </template>
      <template v-slot:[`item.vivienda_ubicacion`]="{ item }">
        <span v-if="item.vivienda_ubicacion">
          {{ JSON.parse(item.vivienda_ubicacion).direccion }}
        </span>
        
      </template>
      <template v-slot:[`item.deudor_nombre_completo`]="{ item }">
        {{ item.deudor_nombre_completo }}
      </template>
      <template v-slot:[`item.campania`]="{ item }">
        {{ getYearMonth(item.fecha_campania) }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ fnGetDateTime(item.createdAt) }}
      </template>
      <template v-slot:[`item.fecha_de_nacimiento`]="{ item }">
        {{ fnGetDateUTC(item.fecha_de_nacimiento) }}
      </template>
      <template v-slot:[`item.flag_tiene_pedido`]="{ item }">
        <span v-if="item.flag_tiene_pedido == 1">Si</span>
        <span v-if="item.flag_tiene_pedido != 1">No</span>
      </template>
      <template v-slot:[`item.fecha_campania`]="{ item }">
        {{ fnGetDateUTC(item.fecha_campania) }}
      </template>
      <template v-slot:[`item.contado`]="{ item }">
        {{ formatCellValue(item.contado, 'boolean') }}
      </template>

      <template v-slot:[`item.deudor`]="{ }">
        deudor
      </template>
      <template v-slot:[`item.flag_persona_referida_por_consejera`]="{ item }">
        {{ formatCellValue(item.flag_persona_referida_por_consejera, 'boolean') }}
      </template>
    </v-data-table>
    <v-row>
      <!-- PAGINACIÓN -->
      <v-col cols="12">
        <v-col offset="9" cols="3">
          <v-select v-model="pageSize" :items="pageSizes" label="Registros por página"
            @change="handlePageSizeChange"></v-select>
        </v-col>
        <v-col class="">
          Total de registros: {{ totalRegistros }}
          <v-pagination class="float-right" v-model="page" :length="totalPages" total-visible="15"
            next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
        </v-col>
      </v-col>
      <!-- FIN PAGINACIÓN -->
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment';
require('moment/locale/es.js');
import { mapActions, mapGetters } from 'vuex';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  data() {
    return {
      loading: false,
      //
      booleanOptions: [
        { text: 'Sí', value: 1 },
        { text: 'No', value: 0 },
      ],
      //pagination
      options: {},
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      totalRegistros: 0,
      //pagination fin
      headers: [
        // { text: 'id', value: 'id', type: 'integer' },
        
        
        // { text: 'Fecha de creación', value: 'createdAt', type: 'date', width: 200  },
        { text: 'Gestión ID', value: 'id', type: 'integer', width: 90 },
        { text: 'Estado', value: 'estado', type: 'string', width: 180 },
        { text: 'Código SAP', value: 'codigo_sap', type: 'string' },
        { text: 'Aplica para contado', value: 'contado', type: 'boolean' },
        { text: 'Campaña', value: 'campania', type: 'string' },
        { text: 'Tipo Cliente', value: 'buro_tipo_de_usuario', type: 'string' },
        { text: 'DUI', value: 'dpi', type: 'string' },
        { text: 'Identificación Extendida en', value: 'identificacion_extendida_en_departamento', type: 'string', width: 190 },
        { text: 'NIT', value: 'nit', type: 'string', width: 90 },
        { text: 'Nombre Completo', value: 'deudor_nombre_completo', type: 'string', width: 200 },
        { text: 'Relación prospecto', value: 'deudor', type: 'deudor' },
        { text: 'Fiador', value: 'fiador_nombre_completo', type: 'string', width: 200  },
        { text: 'Fecha de nacimiento', value: 'fecha_de_nacimiento', type: 'dateUTC' },
        { text: 'Contador', value: 'nocontador_nis', type: 'string' },
        { text: 'Nacionalidad', value: 'nacionalidad', type: 'string' },
        { text: 'Con o sin Pedido', value: 'flag_tiene_pedido', type: 'boolean' },
        { text: 'Ruta', value: 'ruta', type: 'string', width: 130 },
        { text: 'Sector', value: 'sector', type: 'integer', width: 130 },
        { text: 'Región', value: 'region', type: 'string', width: 130 },
        { text: 'División', value: 'division', type: 'string', width: 130 },
        { text: 'Fecha Para La Campaña', value: 'fecha_campania', type: 'dateUTC', width: 120 },
        { text: 'ID Dispositivo', value: 'id_dispositivo', type: 'string', width: 280 },
        { text: 'Celular', value: 'numero_de_celular', type: 'string', width: 120 },
        { text: 'Teléfono de casa', value: 'telefono_de_casa', type: 'string', width: 120 },
        { text: 'Dirección de la consejera', value: 'consejera_direccion', type: 'string', width: 300 },
        { text: 'Tipo Vivienda', value: 'vivienda_tipo', type: 'string' },
        { text: 'Ubicación', value: 'vivienda_ubicacion', type: 'string', width: 200 },
        { text: 'Tiempo de Vivir en el Domicilio', value: 'tiempo_de_vivir_en_domicilio', type: 'string' },
        { text: 'Dirección de Trabajo', value: 'trabajo_direccion', type: 'string', width: 200 },
        { text: 'Teléfono Trabajo', value: 'trabajo_telefono', type: 'string', width: 120 },
        { text: 'Referida', value: 'flag_persona_referida_por_consejera', type: 'boolean' },
        { text: 'Código de Referida', value: 'codigo_referencia', type: 'string', width: 120 },


        { text: 'DUI Frontal', value: 'dui_frontal', type: 'string', width: 120 },
        { text: 'Latitud/ longitud', value: 'latitud_longitud', type: 'string', width: 120 },

        { text: 'DUI Reverso', value: 'dui_reverso', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 1', value: 'latitud_longitud_1', type: 'string', width: 120 },

        { text: 'Persona sosteniendo DUI', value: 'persona_sosteniendo_dui', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 2', value: 'latitud_longitud_2', type: 'string', width: 120 },

        { text: 'Recibo de Servicios', value: 'recibo_de_servicio', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 3', value: 'latitud_longitud_3', type: 'string', width: 120 },

        { text: 'Panorámica de casa', value: 'panoramica_de_casa', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 4', value: 'latitud_longitud_4', type: 'string', width: 120 },

        { text: 'Factura 1 últimos 3 meses', value: 'factura_1_ultimos_3_meses', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 5', value: 'latitud_longitud_5', type: 'string', width: 120 },

        { text: 'Factura 2 últimos 3 meses', value: 'factura_2_ultimos_3_meses', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 6', value: 'latitud_longitud_6', type: 'string', width: 120 },

        { text: 'Factura mayor a un año crédito', value: 'factura_mayor_anio_credito', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 7', value: 'latitud_longitud_7', type: 'string', width: 120 },

        { text: 'Recibo dirección de entrega', value: 'recibo_direccion_de_entrega', type: 'string', width: 120 },
        { text: 'Latitud/ longitud 8', value: 'latitud_longitud_8', type: 'string', width: 120 },

        { text: 'Nombre Ref. 1', value: 'nombre_ref_1', type: 'string', width: 120 },
        { text: 'Teléfono Ref. 1', value: 'telefono_ref_1', type: 'string', width: 120 },
        { text: 'Relación Ref. 1', value: 'relacion_ref_1', type: 'string', width: 120 },
        { text: 'Nombre Ref. 2', value: 'nombre_ref_2', type: 'string', width: 120 },
        { text: 'Teléfono Ref. 2', value: 'telefono_ref_2', type: 'string', width: 120 },
        { text: 'Relación Ref. 2', value: 'relacion_ref_2', type: 'string', width: 120 },
        { text: 'Nombre Ref. 3', value: 'nombre_ref_3', type: 'string', width: 120 },
        { text: 'Teléfono Ref. 3', value: 'telefono_ref_3', type: 'string', width: 120 },
        { text: 'Relación Ref. 3', value: 'relacion_ref_3', type: 'string', width: 120 },
        { text: 'Nombre Ref. 4', value: 'nombre_ref_4', type: 'string', width: 120 },
        { text: 'Teléfono Ref. 4', value: 'telefono_ref_4', type: 'string', width: 120 },
        { text: 'Relación Ref. 4', value: 'relacion_ref_4', type: 'string', width: 120 }
        // Add other headers with types
      ],
      items: [],
      filters: {
        id: '',
        estado: '',
        codigo_sap: '',
        contado: '',
        campania: '',
        buro_tipo_de_usuario: '',
        dpi: '',
        identificacion_extendida_en_departamento: '',
        nit: '',
        deudor_nombre_completo: '',
        deudor: '',
        fiador_nombre_completo: '',
        fecha_de_nacimiento: '',
        nocontador_nis: '',
        nacionalidad: '',
        flag_tiene_pedido: '',
        ruta: '',
        sector: '',
        region: '',
        division: '',
        fecha_campania: '',
        id_dispositivo: '',
        numero_de_celular: '',
        telefono_de_casa: '',
        consejera_direccion: '',
        vivienda_tipo: '',
        vivienda_ubicacion: '',
        tiempo_de_vivir_en_domicilio: '',
        trabajo_direccion: '',
        trabajo_telefono: '',
        flag_persona_referida_por_consejera: '',
        codigo_referencia: '',
        dui_frontal: '',
        latitud_longitud: '',
        dui_reverso: '',
        latitud_longitud_1: '',
        persona_sosteniendo_dui: '',
        latitud_longitud_2: '',
        recibo_de_servicio: '',
        latitud_longitud_3: '',
        panoramica_de_casa: '',
        latitud_longitud_4: '',
        factura_1_ultimos_3_meses: '',
        latitud_longitud_5: '',
        factura_2_ultimos_3_meses: '',
        latitud_longitud_6: '',
        factura_mayor_anio_credito: '',
        latitud_longitud_7: '',
        recibo_direccion_de_entrega: '',
        latitud_longitud_8: '',
        nombre_ref_1: '',
        telefono_ref_1: '',
        relacion_ref_1: '',
        nombre_ref_2: '',
        telefono_ref_2: '',
        relacion_ref_2: '',
        nombre_ref_3: '',
        telefono_ref_3: '',
        relacion_ref_3: '',
        nombre_ref_4: '',
        telefono_ref_4: '',
        relacion_ref_4: ''
      },
      filterConfig: {
        id: true,
        estado: true,
        codigo_sap: true,
        contado: true,
        campania: true,
        buro_tipo_de_usuario: true,
        dpi: true,
        identificacion_extendida_en_departamento: true,
        nit: true,
        deudor_nombre_completo: true,
        deudor: true,
        fiador_nombre_completo: true,
        fecha_de_nacimiento: true,
        nocontador_nis: true,
        nacionalidad: true,
        flag_tiene_pedido: true,
        ruta: true,
        sector: true,
        region: true,
        division: true,
        fecha_campania: true,
        id_dispositivo: true,
        numero_de_celular: true,
        telefono_de_casa: true,
        consejera_direccion: true,
        vivienda_tipo: true,
        vivienda_ubicacion: true,
        tiempo_de_vivir_en_domicilio: true,
        trabajo_direccion: true,
        trabajo_telefono: true,
        flag_persona_referida_por_consejera: true,
        codigo_referencia: true,
        dui_frontal: true,
        latitud_longitud: true,
        dui_reverso: true,
        latitud_longitud_1: true,
        persona_sosteniendo_dui: true,
        latitud_longitud_2: true,
        recibo_de_servicio: true,
        latitud_longitud_3: true,
        panoramica_de_casa: true,
        latitud_longitud_4: true,
        factura_1_ultimos_3_meses: true,
        latitud_longitud_5: true,
        factura_2_ultimos_3_meses: true,
        latitud_longitud_6: true,
        factura_mayor_anio_credito: true,
        latitud_longitud_7: true,
        recibo_direccion_de_entrega: true,
        latitud_longitud_8: true,
        nombre_ref_1: true,
        telefono_ref_1: true,
        relacion_ref_1: true,
        nombre_ref_2: true,
        telefono_ref_2: true,
        relacion_ref_2: true,
        nombre_ref_3: true,
        telefono_ref_3: true,
        relacion_ref_3: true,
        nombre_ref_4: true,
        telefono_ref_4: true,
        relacion_ref_4: true
      },
    };
  },
  computed: {
    modalFechas: {
      get() {
        return this.$store.state.modalFechas;
      },
      set(value) {
        this.$store.dispatch('setModalFechas', value);
      }
    },
    dialogVarSelectedRangueFecha: {
      get() {
        return this.$store.state.dialogVarSelectedRangueFecha;
      },
      set(value) {
        this.$store.dispatch('setDialogVarSelectedRangueFecha', value);
      }
    },
    selectedRangueFecha() {
      return this.$store.state.selectedRangueFecha;
    },
    disabledFecha() {
      return this.$store.state.disabledFecha;
    },
    ...mapGetters([
      'getFirstDay',
      'getLastDay',
    ]),
    filteredHeaders() {
      return this.headers.filter((header) => this.filterConfig[header.value]);
    },
    isFilterChanged() {
      return Object.values(this.filters).some((filter) => filter !== '');
    },
  },
  watch: {
    options: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue) {
        this.main();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {

    async exportToPDF() {
      this.loading = true;
      try {
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Crear el documento PDF en orientación vertical
        const doc = new jsPDF('p', 'pt', 'a4');

        // Preparar los datos para la tabla
        const tableData = allRecords.map((record) =>
          this.headers.map((header) =>
            this.formatCellValue(record[header.value], header.type)
          )
        );

        // Definir las columnas
        const tableColumns = this.headers.map((header) => ({
          header: header.text,
          dataKey: header.value,
        }));

        // Calcular el ancho de página disponible
        const pageWidth = doc.internal.pageSize.getWidth();

        // Añadir la tabla al PDF
        doc.autoTable({
          head: [tableColumns.map((col) => col.header)],
          body: tableData,
          startY: 20,
          styles: {
            fontSize: 6,
            cellPadding: 2,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontSize: 7,
            fontStyle: 'bold',
          },
          columnStyles: {
            0: { cellWidth: 'auto' }, // ID column
            1: { cellWidth: 'auto' }, // Adjust as needed for other columns
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          tableWidth: pageWidth - 20, // Full width minus margins
        });

        // Guardar el archivo PDF
        doc.save('LISTADO DE INFORMACION INGRESADA POR SUPERVISORA.pdf');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a PDF:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    formatCellValue(value, type) {
      if (type === 'deudor') {
        return 'deudor';
      }
      if (type === 'datetimeUTC') {
        return this.fnGetDateUTCTime(value);
      }
      if (type === 'dateUTC') {
        return this.fnGetDateUTC(value);
      }
      if (type === 'date') {
        return this.fnGetDate(value);
      }
      if (type === 'datetime') {
        return this.fnGetDateTime(value);
      }
      if (type === 'boolean') {
        if (value == 1) {
          return 'Si'
        }
        else if (value == 0) {
          return 'No'
        } else {
          return '-'
        }
      }
      // Manejar otros tipos según sea necesario
      return value;
    },
    /** fin pdf */
    async exportToExcel() {
      this.loading = true;
      try {
        let XLSX = require('xlsx');
        // Obtener todos los registros
        const allRecords = await this.getAllRecords();

        // Preparar los datos para el Excel
        const excelData = allRecords.map((record) => {
          let rowData = {};
          this.headers.forEach((header) => {
            // Usar el 'text' como nombre de columna y 'value' para obtener el dato
            rowData[header.text] = this.formatCellValue(
              record[header.value],
              header.type
            );
          });
          return rowData;
        });

        // Crear una hoja de trabajo
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Registros');

        // Guardar el archivo
        XLSX.writeFile(wb, 'LISTADO DE INFORMACION INGRESADA POR SUPERVISORA.xlsx');
        this.loading = false;
      } catch (error) {
        console.error('Error al exportar a Excel:', error);
        this.loading = false;
        // Aquí puedes agregar un manejo de errores más robusto, como mostrar un mensaje al usuario
      }
    },

    async getAllRecords() {
      const totalRecords = this.totalRegistros;
      const params = this.getParams();
      params['$limit'] = totalRecords;
      params['$skip'] = 0;

      try {
        const response = await this.findGestiones({ query: params });
        console.log('todas las gestiones: ', response);
        return response.data;
      } catch (error) {
        console.error('Error al obtener todos los registros:', error);
        throw error;
      }
    },
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    getYearMonth(dateString) {
      // Parse the date string to a Date object
      const date = new Date(dateString);

      // Extract the year and month
      const year = date.getFullYear();
      // Months are zero-indexed, so add 1 and pad with zero if necessary
      const month = String(date.getMonth() + 1).padStart(2, '0');

      // Concatenate year and month
      return `${year}${month}`;
    },
    //
    ...mapActions('GestionesInformacionIngresadaPorSupervisora', {
      findGestiones: 'find',
      createGestiones: 'create',
      patchGestiones: 'patch',
    }),
    ...mapActions([
      'setModalFechas',
      'setDialogVarSelectedRangueFecha',
      'saveDateRange',
    ]),
    /**paginacion */
    handlePageChange(value) {
      this.page = value;
      this.main();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.main();
    },
    /**paginacion fin */
    getParams() {
      const params = {};
      params['$limit'] = this.pageSize;
      params['$skip'] = (this.page - 1) * this.pageSize;
      /** */
      /**fechas */
      /** */
      params['createdAt'] = {
        $gte: this.getFirstDay,
        $lte: this.getLastDay,
      };
      /** */
      /**fechas */

      Object.keys(this.filters).forEach((key) => {
        let filterValue = this.filters[key];
        if (filterValue === '' || filterValue === null || filterValue === undefined) return;

        const header = this.headers.find((h) => h.value === key);
        if (!header) return;

        if (header.type === 'string' && !header.multi) {
          // Trim leading and trailing spaces
          filterValue = filterValue.trim();
          params[key] = { $like: `%${filterValue}%` };
        } else if (header.type === 'integer') {
          params[key] = filterValue;
        } else if (header.type === 'boolean') {
          params[key] = filterValue;
          params[key] = filterValue === 0 ? { $eq: null } : Boolean(filterValue);
        } else if (header.type === 'date' || header.type === 'datetime') {
          filterValue = filterValue.trim();

          let split_filterValue = filterValue.split('-');
          var firstDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 0, 0, 0);
          var lastDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0], 23, 59, 59);


          params[key] = {
            $gte: firstDay,
            $lte: lastDay,
          };

        }
        else if (header.type === 'dateUTC') {
          filterValue = filterValue.trim();

          let split_filterValue = filterValue.split('-');

          let firstDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0] - 2, 23, 59, 59);
          let lastDay = new Date(split_filterValue[2], split_filterValue[1] - 1, split_filterValue[0] - 1, 23, 59, 59);


          params[key] = {
            $gte: firstDay,
            $lte: lastDay,
          };

        }
        // Add more conditions for other types like 'betweendate'
      });

      /** */
      if (
        this.options.sortBy &&
        this.options.sortBy.length === 1 &&
        this.options.sortDesc.length === 1
      ) {
        let sorting = {};
        let flag = this.options.sortDesc[0] ? -1 : 1;
        sorting[this.options.sortBy[0].toString()] = flag;
        params['$sort'] = sorting;
      } else {
        params['$sort'] = { id: -1 };
      }

      return params;
    },
    /** */
    main() {
      this.findGestiones({ query: this.getParams() }).then((r) => {
        this.items = r.data;
        this.totalRegistros = r.total;
        this.totalPages = Math.ceil(
          parseInt(r.total) / parseInt(this.pageSize)
        );
      });
    },
    /** */
    applyFilters() {
      this.page = 1;
      this.main();
      // Function to apply filters and fetch data
      // eslint-disable-next-line no-unused-vars
      const params = this.getParams();
      // Use the params to fetch data from Feathers service
    },
  },
  mounted() {
    this.main();
  },
};
</script>
